import { RelayClientTransport } from '~/modules/remote-mic/network/client/transport/relay-client-transport';
import { lanRelayUrl } from '~/modules/remote-mic/network/server/transport/lan-relay-server';

export class LanRelayClientTransport extends RelayClientTransport {
  protected getUrl = (roomId: string) => lanRelayUrl(roomId);
}
